import { KitType } from '../quote/quote.meta.model'
import { CartMetaStateModel } from './cart.meta.model'

export class ResetCartStateAction {
  public static readonly type = '[CartMeta] Reset to Initial State'
}

export class AddItemToCartAction {
  public static readonly type = '[CartMeta] Add Item to Cart'
  constructor(public payload: { item: any; type: KitType }) {}
}

export class RemoveItemToCartAction {
  public static readonly type = '[CartMeta] Remove Item from Cart'
  constructor(public payload: any) {}
}

export class SetItemsToCartAction {
  public static readonly type = '[CartMeta] Set Items'
  constructor(public payload: CartMetaStateModel) {}
}

export class UpdateCartItemQuantityAction {
  public static readonly type = '[CartMeta] Update Item Quantity'
  constructor(public payload: any) {}
}
